import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';

import { CerAuthorizeService } from '../cer-authorize.service';
import { CerSessionService } from 'src/cer/cer-session/cer-session.service';
import { CerAuthorizePromptService } from '../cer-authorize-prompt-service';
import { CerSessionEnvironmentService } from '@cer/cer-session/cer-session-environment.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizeGuardService {

  constructor(
    private authorize: CerAuthorizeService,
    private prompt: CerAuthorizePromptService,
    private session: CerSessionService,
    private sessionEnvironment: CerSessionEnvironmentService) {
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      if (this.session.isAuthenticated()) {
        resolve(this.hasAccess(route));
      }
      else {
        this.session.userVmGet().then(userVm => {
          var isAuthenticated = this.session.isAuthenticated();
          if (!isAuthenticated) {
            this.authorize.navigateToLogin(state.url);
            resolve(false);
          }
          else {
            resolve(this.hasAccess(route));
          }
        }).catch(error => {
          this.authorize.navigateToLogin(state.url);
          resolve(false);
        });
      }
    }
    );
  }

  private hasAccess(route: ActivatedRouteSnapshot): boolean {
    const access = this.session.hasRouteAccess(route)
    if (!access.hasAccess) {
      const sessionState = this.session.sessionState$.getValue();
      if (sessionState != 'active') {
        this.prompt.sessionStatePrompt(sessionState);
      }
      else {
        this.prompt.errorNoAccess(access.route.url.join("/"));
        if (access.route.url.length > 1) {
          this.authorize.navigateToHome();
        }
      }
    }
    return access.hasAccess;
  }
}

export const AuthorizeGuard: CanActivateFn =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    return inject(AuthorizeGuardService).canActivate(route, state);
  };
